import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

// Modern kit — a modern square concrete column: a plain 0.3 x 0.3 m shaft
// one storey (2.6 m) tall on a thin darker base.
const CONCRETE = "#9a9a94";
const BASE = "#7c7c77";

export const columnSquare = defineModel({
  id: "column-square",
  batchId: "modern",
  name: "Square column",
  tags: ["modern", "interior", "outdoor", "structure", "column", "concrete"],
  summary: "A modern square concrete column, 0.3 x 0.3 m, one storey tall.",
  description:
    "A one-tile modern structural column of the Modern Living kit: a plain " +
    "0.3 x 0.3 m concrete shaft, 2.6 m tall, on a thin darker base plate. " +
    "Carries open-plan floors, carports and canopies.",
  tiles: { w: 1, h: 1 },
  footprint: 1.4,
  parts(): Part[] {
    return [
      // thin darker base plate
      { geometry: new THREE.BoxGeometry(0.36, 0.06, 0.36), color: BASE, position: [0, 0.03, 0] },
      // concrete shaft up to 2.6
      { geometry: new THREE.BoxGeometry(0.3, 2.54, 0.3), color: CONCRETE, position: [0, 1.33, 0] },
    ];
  },
  animations: [],
});
